<template>
  <div class="nav-picker-container">

    <div class="reset-area">
      <transition name="fade">
        <button 
          v-if="selectedYear || selectedLocation || selectedProjectId" 
          @click="resetAll"
          class="btn-reset"
        >
          ← SHOW ALL PROJECTS
        </button>
      </transition>
    </div>

     <!-- Client Selector -->
    <div class="nav-group client-group">
      <h6 class="nav-label">Client</h6>
      <select class="client-select" v-model="selectedClientId">
        <option value="" disabled>Select a client...</option>
        <option v-for="client in clients" :key="client.id" :value="client.id">
          {{ client.name }}
        </option>
      </select>
    </div>

    <div class="nav-group">
      <h6 class="nav-label">Year</h6>
      <div class="nav-list">
        <div v-for="year in visibleYears" :key="year"
            @click="toggleFilter('year', year)"
            :class="['nav-item', selectedYear === year ? 'active-bold' : '']">
        {{ year }}
        </div>  
        <div v-if="visibleYears.length === 0" class="text-muted small italic">
          No years with projects.
         </div>
      </div>
    </div>

    <div class="nav-group">
      <h6 class="nav-label">Location</h6>
      <div class="nav-list">
        <div v-for="loc in visibleLocations" :key="loc"
            @click="toggleFilter('location', loc)"
            :class="['nav-item', selectedLocation === loc ? 'active-bold' : '']">
        {{ loc }}
        </div>
        <div v-if="visibleLocations.length === 0" class="text-muted small italic">
          No locations.
         </div>
      </div>
    </div>

    <div class="nav-group">
      <h6 class="nav-label">Projects</h6>
      <div class="project-list">
        <div v-for="proj in visibleProjects" :key="proj.id"
            @click="selectedProjectId = proj.id"
            :class="['project-item', selectedProjectId === proj.id ? 'active-project' : '']">
        <span class="proj-name">{{ proj.year }} - {{ proj.name }}</span>
        <button @click.stop="sendToProj(proj)" class="btn btn-success small-btn">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="white" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>
        </div>
        
        <div v-if="visibleProjects.length === 0" class="text-muted small italic">
          No matching projects found.
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import { useGlobals } from '../../composables/globals';
import { frontendRoot } from '/src/composables/apiLink.js'

import projects from '@/composables/fe_projects.js'
const { allowedClients } = projects()
const { selectedLocation, selectedProjectId, selectedYear, selectedClientId } = useGlobals()

const clients = ref([])



onMounted(() => {
  // This logic runs once the component is added to the DOM

    allowedClients()
    .then(response => {
        //console.log("RESPONSE4444444a: ", response)
        if (response.length > 0){
              clients.value = response.map(item => ({
                id: item.clientId,
                name: item.clientName
              }));
        } 
            
    }
    ).catch(error => {
        console.log("ERROR fetching allowed clients: ", error)
        //next( {name:'select-client', query: {'goto': to.path}} )
    })
  // clients.value = [
  //   { id: 1, name: "Acme Construction Ltd." },
  //   { id: 2, name: "Prairie Infrastructure Group" },
  //   { id: 3, name: "Summit Civil Engineering" },
  //   { id: 4, name: "Foothills Contracting Inc." },
  //   { id: 5, name: "Alberta Land Developers" },
  // ];

});


const props = defineProps({
  allProjects: { type: Array }
})

watch(props, () => {
  console.log("HERE @@@@@@@@@@@@@@@@@@@@@@@", props.allProjects)
})

// --- COMPUTED LOGIC ---
const uniqueYears = computed(() => [...new Set(props.allProjects.map(p => p.year))].sort().reverse());
const uniqueLocations = computed(() => [...new Set(props.allProjects.map(p => p.location))].sort());
const sortedProjects = computed(() => [...new Set(props.allProjects.map(p => p.name))].sort());


const sendToProj = (proj) => {
  window.location.href = `${frontendRoot}/site/${proj.clientId}/${proj.id}`
  // console.log(`${frontendRoot}/site/${proj.clientId}/${proj.id}`)
}
// 1. Years that have projects for the selected Location
const visibleYears = computed(() => {
    // If a project is clicked, only show THAT project's year
  if (selectedProjectId.value) {
    const p = props.allProjects.find(proj => proj.id === selectedProjectId.value);
    return p ? [p.year] : [];
  }

  if (!selectedLocation.value) return uniqueYears.value;
  return uniqueYears.value.filter(year => 
    props.allProjects.some(p => p.year === year && p.location === selectedLocation.value)
  );
});

// 2. Locations that have projects for the selected Year
const visibleLocations = computed(() => {
  // If a project is clicked, only show THAT project's location
  if (selectedProjectId.value) {
    const p = props.allProjects.find(proj => proj.id === selectedProjectId.value);
    return p ? [p.location] : [];
  }
  if (!selectedYear.value) return uniqueLocations.value;
  return uniqueLocations.value.filter(loc => 
    props.allProjects.some(p => p.location === loc && p.year === selectedYear.value)
  );
});

// 3. Projects that match BOTH (The missing piece)
const visibleProjects = computed(() => {
  // NEW: If a project is clicked, hide all other projects
  if (selectedProjectId.value) {
    return props.allProjects.filter(p => p.id === selectedProjectId.value);
  }

  // Otherwise, do the normal filtering by Year/Location
  return props.allProjects.filter(p => {
    const yearMatch = !selectedYear.value || p.year === selectedYear.value;
    const locMatch = !selectedLocation.value || p.location === selectedLocation.value;
    return yearMatch && locMatch;
  });
});



// --- HELPER METHODS FOR THE "DANCE" ---
const isYearValidForLocation = (year) => {
  if (!selectedLocation.value) return true;
  return props.allProjects.some(p => p.year === year && p.location === selectedLocation.value);
};

const isLocationValidForYear = (loc) => {
  if (!selectedYear.value) return true;
  return props.allProjects.some(p => p.location === loc && p.year === selectedYear.value);
};

// --- ACTIONS ---
const toggleFilter = (type, value) => {
  selectedProjectId.value = null; // Always clear specific project on new filter
  
  if (type === 'year') {
    selectedYear.value = selectedYear.value === value ? null : value;
    selectedLocation.value = null; // Clear Location if Year is picked
  } else {
    selectedLocation.value = selectedLocation.value === value ? null : value;
    selectedYear.value = null; // Clear Year if Location is picked
  }
};

const resetAll = () => {
  selectedYear.value = null;
  selectedLocation.value = null;
  selectedProjectId.value = null;
};
</script>

<style scoped>
.btn {
  flex-shrink: 0; 
  width: 24px;
  height: 24px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
}

.nav-picker-container {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  color: #333;
}

.reset-area {
  height: 40px;
  display: flex;
  align-items: center;
  width: 100%;

}

.btn-reset {
  background: none;
  border: 1px solid #ddd;
  color: var(--brand-primary);
  font-size: 0.7rem;
  font-weight: bold;
  padding: 4px 12px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-reset:hover {
  background: #f8f8f8;
  border-color: #999;
}

.nav-group {
  margin-bottom: 2rem;
  margin-left:7px;
}

.nav-label {
  font-size: medium;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: rgb(13, 72, 84);
  margin-bottom: 0px;
  margin-left:5px;
  border-bottom: 1px solid #eee;
  padding-bottom: 4px;
  font-weight: bolder;
}

.nav-item {
  cursor: pointer;
  font-size: small;
  padding: 3px 0;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.project-item {
  cursor: pointer;
  padding: 4px;
  padding-left:0px;
  margin-bottom: 3px;
  border-radius: 6px;
  display: flex;
  gap: 10px;
  transition: all 0.3s ease;
  font-size: small;
  justify-content: space-between;
  align-items: center;
}

.proj-year {
  font-size: 0.7rem;
  background: #eee;
  padding: 2px 5px;
  border-radius: 4px;
  height: fit-content;
}

/* THE DANCE STATES */
.active-bold {
  font-weight: 800;
  color: #27ae60;
  transform: scale(1.1) translateX(12px);
}

.dimmed {
  opacity: 0.2;
}

.disabled {
  opacity: 0.05;
  pointer-events: none;
}

.active-project {
  background: rgba(39, 174, 96, 0.1);
  color: #27ae60;
  font-weight: 600;
  transform: translateX(5px);
}

.dimmed-project {
  opacity: 0.3;
  filter: grayscale(1);
}

/* Vue Animations */
.fade-enter-active, .fade-leave-active { transition: opacity 0.3s; }
.fade-enter-from, .fade-leave-to { opacity: 0; }


/* Ensure the container doesn't grow past the sidebar height */
.nav-picker-container {
  display: flex;
  flex-direction: column;
  height: 100%; /* Important: fill the parent div */
  overflow: hidden; 
}

/* Make each list scrollable if it has too many items */
.nav-list, .project-list {
  overflow-y: auto;
  max-height: 175px; /* Adjust based on your UI needs */
  padding-right: 8px; /* Space for the scrollbar */
}

/* Custom "Thin" Scrollbar for a cleaner look on Chrome/Safari */
.nav-list::-webkit-scrollbar, 
.project-list::-webkit-scrollbar {
  width: 4px;
}

.nav-list::-webkit-scrollbar-thumb, 
.project-list::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
}

.nav-list::-webkit-scrollbar-thumb:hover, 
.project-list::-webkit-scrollbar-thumb:hover {
  background: #27ae60; /* Matches your S. Alberta Green */
}

.nav-list, .project-list {
  scrollbar-gutter: stable; /* Keeps the space reserved even when empty */
  overflow-y: auto;
}
/* Allow text to wrap if it's too long, or use ellipsis (...) */
.nav-item, .project-item {
    white-space: normal; /* Allows the name to go to 2 lines if needed */
    /* OR use these 3 lines if you want it to stay 1 line with "..." */
    /* overflow: hidden; */
    /* text-overflow: ellipsis; */
    /* white-space: nowrap; */
}
#sidebar {
    height: 100vh; /* Or whatever your sidebar height is */
    display: flex;
    flex-direction: column;
    overflow: hidden; 
}
.nav-list, .project-list {
    overflow-y: auto !important; /* Force the scrollbar back */
    overflow-x: hidden;         /* Prevent side-to-side shaking */
}
.proj-name {
    flex: 1;          /* takes all available space */
  min-width: 0;     /* allows ellipsis to work inside flex */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-transform: uppercase;
}

.client-select {
  width: 100%;
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 0.9rem;
  color: #333;
  background: white;
  cursor: pointer;
  outline: none;
  transition: border-color 0.2s;
}

.client-select:focus {
  border-color: #27ae60;
}

.client-group {
  margin-bottom: 0px;
  padding-bottom: 30px;
}
.small-btn {
  width: 12px;
  height: 12px;
  padding: 0;
}
</style>